// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class IndicesService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getMainAssetClassIndices() {
        return this.getAllAssetClassIndices('root');
    }
    getAllAssetClassIndices(parentAssetClass) {
        const urlParams = { asset_class: parentAssetClass };
        const url = this.urlsService.getUrl(this.urlsService.INDICES.ASSET_CLASS_DATA, urlParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    getIndicesPageGainersLosers(indexFamily, periodicity) {
        const queryParams = {
            indexFamily: encodeURIComponent(indexFamily),
            periodicity,
        };
        const url = this.urlsService.getUrl(this.urlsService.INDICES.INDICES_FAMILY_PAGE_GAINERS_LOSERS, {}, queryParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    getIndicesData(indexFamily, columns) {
        const queryParams = {
            indexFamily: encodeURIComponent(indexFamily),
            columns,
        };
        const url = this.urlsService.getUrl(this.urlsService.INDICES.INDICES_FAMILY_DATA, {}, queryParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    getMajorIndicesData(indices, columns) {
        const queryParams = {
            indices: indices.map((index) => encodeURIComponent(index)),
            columns,
        };
        const url = this.urlsService.getUrl(this.urlsService.INDICES.INDICES_FAMILY_DATA, {}, queryParams);
        return this.ajaxService.getDataObserveBody(url);
    }
}
IndicesService.ɵfac = function IndicesService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IndicesService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
IndicesService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IndicesService, factory: IndicesService.ɵfac, providedIn: 'root' });
